var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2929 1.29289C8.68342 0.902369 9.31659 0.902369 9.70711 1.29289L15.7071 7.29289C16.0976 7.68342 16.0976 8.31658 15.7071 8.70711L9.70711 14.7071C9.31659 15.0976 8.68342 15.0976 8.2929 14.7071C7.90237 14.3166 7.90237 13.6834 8.2929 13.2929L12.5858 9L1 9C0.447716 9 0 8.55228 0 8C0 7.44771 0.447716 7 1 7H12.5858L8.2929 2.70711C7.90237 2.31658 7.90237 1.68342 8.2929 1.29289Z",
    fill: "currentColor"
  })));
}

export default SvgArrowRight;